import { SetStateAction, useEffect } from "react";
import classNames from "classnames";
import styles from "./Sidebar.module.scss";
import { ReactComponent as Logo } from "../../Img/logo/logo-white.svg";
import { ReactComponent as XIcon } from "monoff-web-design-system/src/img/icon/24/X.svg";
import { Link, useLocation } from "react-router-dom";
export default function Sidebar({
  side,
  isOpen,
  setOpen,
  onClose,
  onClick,
  isDarkMode,
  select,
}: {
  side: any;
  isOpen: boolean;
  setOpen: React.Dispatch<SetStateAction<boolean>>;
  onClose: () => void;
  onClick: (e: any) => void;
  isDarkMode: boolean;
  select: (menu: string) => boolean;
}) {
  const location = useLocation();
  const handleClose = async (e: any) => {
    let sideArea = side.current;
    let sideCildren = side.current.contains(e.target);
    if (isOpen && (!sideArea || !sideCildren)) {
      setOpen(false);
    }
  };
  useEffect(() => {
    window.addEventListener("click", handleClose);
    return () => {
      window.removeEventListener("click", handleClose);
    };
  });

  return (
    <div className={styles.container}>
      <div className={styles.sideContainer}>
        <div
          ref={side}
          className={!isDarkMode ? styles.sidebar : styles.dark_sidebar}
        >
          <div className={!isDarkMode ? styles.content : styles.dark_mode}>
            <div className={styles.logoBox}>
              <div className={styles.logo}>
                <Logo />
                <p className={`${styles.logo_text} label-kr-L`}>CAREERS</p>
              </div>
              <XIcon
                onClick={onClose}
                className={!isDarkMode ? styles.xIcon : styles.dark_xIcon}
              />
            </div>
            <div className={styles.menuList}>
              <Link
                to="/"
                onClick={onClick}
                className={classNames(
                  select("메인") || location.pathname === "/"
                    ? styles.activeMenu
                    : styles.inactiveMenu,
                  "label-kr-L"
                )}
              >
                메인
              </Link>
              <Link
                to="/culture"
                onClick={onClick}
                className={classNames(
                  select("문화와 비전") || location.pathname === "/culture"
                    ? styles.activeMenu
                    : styles.inactiveMenu,
                  "label-kr-L"
                )}
              >
                문화와 복지
              </Link>
              <Link
                to="/position"
                onClick={onClick}
                className={classNames(
                  select("채용 중인 직무") ||
                    location.pathname.split("/")[1].includes("position")
                    ? styles.activeMenu
                    : styles.inactiveMenu,
                  "label-kr-L"
                )}
              >
                채용 중인 직무
              </Link>
              {/* <Link
                    to="/faq"
                    onClick={onClick}
                    className={classNames(
                      select("자주 묻는 질문") || location.pathname === "/faq"
                        ? styles.activeMenu
                        : styles.inactiveMenu
                    )}
                  >
                    자주 묻는 질문
                  </Link> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
